import {MatPaginatorIntl} from '@angular/material';
import {Injectable} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { first,
  tap } from 'rxjs/operators';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  constructor(public translate: TranslateService) {
    super();

    this.translate.get("DX.CORE.PAGINATOR.ITEMS_PER_PAGE_LABEL").pipe(
      first(),
      tap(itemsPerPageLabel => this.itemsPerPageLabel = itemsPerPageLabel),
      tap(() => this.changes.next())
    ).subscribe();
  }

}
